/* eslint-disable import/no-unresolved */
import React from "react";
import ShopCart from "components/pages/user/checkout/shopCart";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopCart = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <ShopCart {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopCart);
